import propertyOptionItems from 'client/helpers/propertyOptionItems';
import bedroomOptionItems from 'client/helpers/bedroomOptionItems';

export default {
  minRentPrice: {
    id: 'minRentPrice',
    label: 'Min Rent Price',
    type: 'currency',
    placeholder: 850,
  },
  maxRentPrice: {
    id: 'maxRentPrice',
    label: 'Max Rent Price',
    type: 'currency',
    placeholder: 4000,
  },
  minSquareFeet: {
    id: 'minSquareFeet',
    label: 'Min',
    type: 'number',
    placeholder: 'min. sqft',
  },
  maxSquareFeet: {
    id: 'maxSquareFeet',
    label: 'Max',
    type: 'number',
    placeholder: 'max. sqft',
  },
  area: {
    id: 'area',
    label: 'Location',
    type: 'location',
  },
  bedrooms: {
    id: 'bedrooms',
    label: 'Beds',
    type: 'tab-list',
    multi: true,
    tabList: bedroomOptionItems,
  },
  pets: {
    id: 'pets',
    label: 'Pets',
    type: 'checkbox-list',
    checkboxList: [
      { value: 'cat', label: 'Cat' },
      { value: 'dog', label: 'Dog' },
    ],
  },
  moveInDate: {
    id: 'moveInDate',
    label: 'Move-in Date',
    type: 'date',
  },
  propertyTypes: {
    id: 'propertyTypes',
    label: 'Property Type',
    type: 'option-list',
    multi: true,
    optionList: propertyOptionItems,
  },
  bathrooms: {
    id: 'bathrooms',
    label: 'Baths',
    type: 'tab-list',
    tabList: [
      { value: 0, label: 'Any' },
      { value: 1, label: '1+' },
      { value: 2, label: '2+' },
      { value: 3, label: '3+' },
      { value: 4, label: '4+' },
    ],
  },
  squareFeet: {
    id: 'squareFeet',
    label: 'Square Feet',
    type: 'option-list',
    optionList: [
      { id: '<750', label: '< 750 square feet' },
      { id: '750—1,000', label: '750 – 1,000 square feet' },
      { id: '1,000-1,250', label: '1,000 – 1,250 square feet' },
      { id: '1,250-1,500', label: '1,250 – 1,500 square feet' },
      { id: '1,500-1,750', label: '1,500 – 1,750 square feet' },
      { id: '1,750+', label: '1,750+ square feet' },
    ],
  },
  unitAmenities: {
    id: 'unitAmenities',
    label: 'Unit Amenities',
    type: 'option-list',
    multi: true,
    allowEmptyArray: true,
    optionList: [
      { value: 'washer/dryer - in unit', label: 'Washer/Dryer included in the unit' },
      { value: 'washer/dryer - connections', label: 'Washer/Dryer connections available' },
      { value: 'pool', label: 'Pool' },
      { value: 'garage', label: 'Garage' },
      { value: 'private fenced yard', label: 'Private Fenced Yard' },
      { value: 'wood flooring', label: 'Wood Flooring' },
      { value: 'tile flooring', label: 'Tile Flooring' },
      { value: 'no carpet', label: 'No Carpet' },
      { value: 'gas stove', label: 'Gas Stove' },
    ],
  },
  buildingAmenities: {
    id: 'buildingAmenities',
    label: 'Building Amenities',
    type: 'option-list',
    multi: true,
    optionList: [],
  },
  section8: {
    id: 'section8',
    label: 'Section 8 / Housing Voucher',
    type: 'checkbox',
    multi: false,
  },
};
